export class AsyncChannel {
    queue = [];
    resolvers = [];
    closed = false;
    async send(value) {
        if (this.closed)
            return;
        const resolver = this.resolvers.shift();
        if (resolver) {
            resolver({ value, done: false });
            return;
        }
        this.queue.push(value);
    }
    close() {
        if (this.closed)
            return;
        this.closed = true;
        for (const resolver of this.resolvers) {
            resolver({ value: undefined, done: true });
        }
        this.resolvers = [];
        this.queue = [];
    }
    [Symbol.asyncIterator]() {
        return {
            next: () => {
                if (this.queue.length > 0) {
                    const value = this.queue.shift();
                    return Promise.resolve({ value, done: false });
                }
                if (this.closed) {
                    return Promise.resolve({ value: undefined, done: true });
                }
                return new Promise((resolve) => {
                    this.resolvers.push(resolve);
                });
            },
        };
    }
}
